<template>
  <j-select
    v-if="$vuetify.breakpoint.xsOnly"
    label="Gabarit d'affichage"
    :items="getInventoryTemplates"
    :value="value"
    item-value="id"
    item-text="name"
    hide-details
    solo
    close-on-select
    @change="v => $emit('input', v)"
  ></j-select>
  <v-autocomplete
    v-else
    :prepend-inner-icon="icon ? 'fa-list-alt' : ''"
    label="Gabarit d'affichage"
    :items="getInventoryTemplates"
    item-value="id"
    item-text="name"
    :value="value"
    solo
    hide-details
    clearable
    autocomplete="off"
    :loading="loading"
    @change="v => $emit('input', v)"
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "InventoryTemplateSelector",
  props: {
    value: {
      required: true
    },
    icon: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getInventoryTemplates"])
  }
};
</script>

<style></style>
